module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "frontmatter",
      "id": "cont",
      "title": "Contents"
    }
  }, [_c('p', {
    staticClass: "h2f1"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_4",
      "title": "4"
    }
  }, [_vm._v("CONTENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "image0b"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "3",
      "src": "images/line.jpg",
      "width": "800"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "toc0",
    attrs: {
      "id": "book"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Book"
    }
  }, [_vm._v("How to Use This Book")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "pt1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Part001"
    }
  }, [_vm._v("Part I: Organization")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ch1"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/text/Chapter001"
    }
  }, [_vm._v("Chapter 1: Introduction to Creative Journaling")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ch2"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/Chapter002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 2: Supplies & Tools")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ch3"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/Chapter003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 3: Tips & Tricks")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ch4"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/Chapter004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4: Building a Foundation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ch5"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/Chapter005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5: Planning Pages & Templates")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "pt2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Part002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part II: Inspiration")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ch6"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/Chapter006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6: Special Pages & Collections")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ch7"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/Chapter007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7: Header Styles")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ch8"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/Chapter008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8: Banners, Frames, & Borders")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ch9"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/Chapter009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9: Doodle Embellishments")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ch10"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/Chapter010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10: Inspiration from Real Journals")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "res"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Resources",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Resources")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ack"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Acknowledgments",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments, and About the Author")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c2f62c52","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Contents.vue
// module id = 69
// module chunks = 0